module.exports = __webpack_public_path__ + "img/imgb3.cec05d27.png";